import React, { useState } from "react";
import { useAuth } from "@/App";
import { useNavigate } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { LogOut } from "lucide-react";

/**
 * ConfirmLogoutButton - Wraps children (default: LogOut button UI) with a
 * confirm dialog before actually logging out.
 */
const ConfirmLogoutButton = ({ children, className = "", testId = "logout-btn", redirectTo = "/" }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = () => {
    logout();
    setOpen(false);
    navigate(redirectTo);
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        {children || (
          <button className={className} data-testid={testId}>
            <LogOut className="w-5 h-5" />
            <span className="font-medium">Logout</span>
          </button>
        )}
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="confirm-logout-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Log out?</AlertDialogTitle>
          <AlertDialogDescription>
            You'll need to sign in again to access your dashboard.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-logout-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={doLogout} data-testid="confirm-logout-confirm">
            Yes, Log out
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmLogoutButton;
